import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cart.svg'


const _hoisted_1 = { class: "cartResume" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cartIcon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "cartText" }
const _hoisted_4 = { class: "cartCounters" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          class: "text-gray",
          localizedKey: "Il mio carrello",
          text: "Il mio carrello"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(_ctx.itemsCount), 1),
        _createElementVNode("div", null, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.totalAmount)), 1)
      ])
    ])
  ]))
}